module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  props:
    c:                  { default: 'default' }    # collection name
    i:                  { default: null }         # item name
    thumbUrl:           { default: null }         # thumb image url
    imageUrl:           { default: null }         # large image url
    title:              { default: null }         # used as alt-tag and description in lightbox
    previewShowCaption: { default: false }        # show caption already in preview
    previewShadow:      { default: false }        # add shadow to image

  computed:

    isPreviewCaptionVisible: ->
      @previewShowCaption == true || @previewShowCaption == 'true'

    hasPreviewShadow: ->
      @previewShadow != false && @previewShadow != 'false'

  methods:

    onClick: ->
      @.$store.dispatch('lightbox/open', { collection: @c, id: @i })

  created: ->
    @.$store.dispatch('lightbox/register', {
      collection: @c
      id:         @i
      thumbUrl:   @thumbUrl
      imageUrl:   @imageUrl
      title:      @title
    })

  beforeDestroy: ->
    @.$store.dispatch('lightbox/unregister', {
      collection: @c
      id:         @i
    })



// WEBPACK FOOTER //
// ./assets/js/frontend/components/lightbox_item/index.coffee